import { closingColon } from "./helpers.js";

export const TextOperations = {
    isTrue: (arg) => {
      let matcher = /\bmashoko/g;
      return matcher.test(arg);
    },

    hasOpened: true,

    // FIXME: should account for the classname and the inline styles
    openingColon: (arg) => {
      // will have a name and inline styles
      arg = arg.replace(/\bmashoko\b/, "<span ").replace(":", "");
      return arg;
    },


    getText: (readLines, index) => { // get the text iside of the mahoko tag
        // Once the mshoko taga has been opened, there is either text on the next line,
        // or a closig tag which means there is nothing inside the tag, and this will warn not error
       for (let i = index; i < readLines.length; i++){
        if(TextOperations.hasOpened){
            // console.log(readLines[i])
        }
       }

      
    }
  };
  
  export const runTextOperations = (readLinesOriginal, readLines, errors) => {
    for (var i = 0; i < readLines.length; i++) {
      let x = readLines[i];
      if (TextOperations.isTrue(x)) {
        // TextOperations.closingColon(readLines, i);
        closingColon(readLines,i,TextOperations,'</span>');
        let text = TextOperations.getText(readLines, i);
      
        // console.log('found it')/
        readLines[i] = TextOperations.openingColon(x);
      } else {
      }
    }
    return readLines;
  };
  